import { render, staticRenderFns } from "./VxCellDetailsToggler.vue?vue&type=template&id=72a865f8&"
import script from "./VxCellDetailsToggler.vue?vue&type=script&lang=js&"
export * from "./VxCellDetailsToggler.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports